import './index.css';
import ReactDOM from 'react-dom';
import GameLayout from './GameLayout';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga';
import { Keys } from './util.js';

ReactGA.initialize(Keys.GOOGLE_TRACKING_ID);

ReactDOM.render(
  <GameLayout />,
  document.getElementById('root')
);

reportWebVitals();
